import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { ZeekrHome } from './types';

export function useZeekrHomeData(): Page<ZeekrHome>['templateFields'] {
  return useCurrentPage<Page<ZeekrHome>>().templateFields;
}
